const Home = () => import(/* webpackChunkName: "Home" */ '@/views/Home')
const NotFound = () => import(/* webpackChunkName: "NotFound" */ '@/views/error/NotFound')
const Login = () => import(/* webpackChunkName: "Login" */ '@/views/login/Login')
const DashBoard = () => import(/* webpackChunkName: "DashBoard" */ '@/views/dashboard/ChildDashboard/dashboard')
const appList = () => import(/* webpackChunkName: "appList" */ '@/views/appMarket/ApplyShelf')
const appUpload = () => import(/* webpackChunkName: "appUpload" */ '@/views/appMarket/ApplyUpload')
const appCheck = () => import(/* webpackChunkName: "appCheck" */ '@/views/appMarket/AppCheck')
const appInside= () => import(/* webpackChunkName: "appInside" */ '@/views/appMarket/AppInside')
const AppManage = () => import(/* webpackChunkName: "AppManage" */ '@/views/appMarket/AppManage')
const appAdd = () => import(/* webpackChunkName: "appAdd" */ '@/views/appMarket/ApplyAdd')
// const AppDeployConfig = () => import('@/views/appMarket/appDeployComponents/AppDeploy')
//厂商型号
const ManufacturerDvcType = () => import(/* webpackChunkName: "ManufacturerDvcType" */ '@/views/manufacturer/manufacturerDvcType')
//应用参数配置
const AppParamConfig = () => import(/* webpackChunkName: "AppParamConfig" */ '@/views/appMarket/AppParamConfig')
const AddAppParamConfig = () => import(/* webpackChunkName: "AddAppParamConfig" */ '@/views/appMarket/AddAppParamConfig')
const EditAppParamConfig = () => import(/* webpackChunkName: "EditAppParamConfig" */ '@/views/appMarket/EditAppParamConfig')
const ViewAppParamConfig = () => import(/* webpackChunkName: "ViewAppParamConfig" */ '@/views/appMarket/ViewAppParamConfig')


//设备管理
const OrgDevice = () => import(/* webpackChunkName: "OrgDevice" */ '@/views/device/OrgDevice')
const organizationManagement = () => import(/* webpackChunkName: "organizationManagement" */ '@/views/organizationManagement/organizationManagement')
const orgRepository = () => import(/* webpackChunkName: "orgRepository" */ '@/views/organizationManagement/orgRepository')
const operationLog = () => import(/* webpackChunkName: "operationLog" */ '@/views/baseSetting/operationLog')
const operateDate = () => import(/* webpackChunkName: "operateDate" */ '@/views/account/OperateDate')
const LogManage = () => import(/* webpackChunkName: "LogManage" */ '@/views/logManage/logManage')

const platformSettings = () => import(/* webpackChunkName: "platformSettings" */ '@/views/baseSetting/platformSettings')
//OS管理
const os = () => import(/* webpackChunkName: "os" */ '@/views/os/OSManagement')

const deviceTask = () => import(/* webpackChunkName: "deviceTask" */ '@/views/deviceTask/deviceTask')
//
const OccupyScreen = () => import(/* webpackChunkName: "OccupyScreen" */ '@/views/appMarket/OccupyScreen')
const deviceLifeCycle = () => import(/* webpackChunkName: "deviceLifeCycle" */ '@/views/deviceLifeCycle/deviceLifeCycle')
const AuthorityManagement = () => import(/* webpackChunkName: "AuthorityManagement" */ '@/views/authority/AuthorityManagement')
const otaParamManagement = () => import(/* webpackChunkName: "otaParamManagement" */ '@/views/otaParamManagement/otaParamManagement')
const unlock = () => import(/* webpackChunkName: "unlock" */ '@/views/login/UnlockAccount')
const locationChange = () => import(/* webpackChunkName: "locationChange" */ '@/views/report/locationChange')
const netConnectAnalysis = () => import(/* webpackChunkName: "netConnectAnalysis" */ '@/views/report/netConnectAnalysis')
const aliveDevice = () => import(/* webpackChunkName: "aliveDevice" */ '@/views/report/aliveDevice/aliveDeviceAnalysis')
// 报表
const dvcConnAnalysis = () => import(/* webpackChunkName: "dvcConnAnalysis" */ '@/views/report/dvcConnAnalysis')
// const otp = () => import('@/views/opt/optManagement')
const silentApp = () => import(/* webpackChunkName: "silentApp" */ '@/views/sysCustomization/silentAppComponents/SilentApp')

const ConfigurationManagement = () => import(/* webpackChunkName: "ConfigurationManagement" */ '@/views/policyManagement/configurationManagement/configurationManagement')
//
const customDesk = () => import(/* webpackChunkName: "customDesk" */ '@/views/deviceTask/customDesk/customDeskConfig')
const BootAnimation = () => import(/* webpackChunkName: "BootAnimation" */ '@/views/deviceTask/BootAnimation/bootAnimation')

//流量管理
const FlowManage = () => import(/* webpackChunkName: "FlowManage" */ '@/views/FlowManagement/FlowManage')
const flowLimitWarn = () => import(/* webpackChunkName: "flowLimitWarn" */ '@/views/FlowManagement/flowLimit/flowLimit')

const mas = () => import(/* webpackChunkName: "mas" */ '@/views/mas/masList')
const paramDict = () => import(/* webpackChunkName: "paramDict" */ '@/views/paramManage/paramDict')
// const paramManage = () => import('@/views/paramManage/paramManage')

const firstLogin = () => import(/* webpackChunkName: "firstLogin" */ '@/views/login/FirstLogin')
const bulkTask = () => import(/* webpackChunkName: "bulkTask" */ '@/views/report/bulkTask')
const exportTask = () => import(/* webpackChunkName: "exportTask" */ '@/views/report/exportTask')

const deviceAppInstallStatistics = () => import(/* webpackChunkName: "deviceAppInstallStatistics" */ '@/views/report/deviceAppInstallStatistics')



const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/index',
    children: [  // 所有只有一级的导航放到这里，并指定level=1
      {
        path: '/index',
        name: 'yd.menu.dashboard',
        component: DashBoard,
        icon: 'icon-wujiaoxing',
        level: 1,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appList',
        component: appList,
        icon: 'icon-z-applist',
        name: 'yd.menu.applist',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/authorityManagement',
        component: AuthorityManagement,
        icon: 'icon-z-applist',
        name: 'yd.menu.authorityManagement',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/otaParamManagement',
        component: otaParamManagement,
        icon: 'icon-z-applist',
        name: 'yd.menu.otaParamManagement',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appUpload',
        component: appUpload,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_app_upload',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appCheck',
        component: appCheck,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_app_check',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appInside',
        component: appInside,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_inside_app',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        name:"yd.menu.app_add",
        // name:"AppAdd",
        path: '/appUpload/appAdd/',
        component: appAdd,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },

      },
      {
        name:"yd.menu.app_param_config",
        path: '/appParamConfig/list',
        component: AppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },

      },
      {
        name:"yd.menu.app_manage",
        path: '/app/appManage',
        component: AppManage,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },
      },
      {
        name:"yd.menu.occupy_screen",
        path: '/app/occupyScreen',
        component: OccupyScreen,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },
      },
      //厂商类型
      {
        path: '/manufacturer',
        name: 'yd.menu.manufacturer_dvc_type',
        component: ManufacturerDvcType,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      //设备详情列表

      {
        path: '/device',
        name: 'yd.menu.device_detail',
        component: OrgDevice,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/tasks',
        name: 'yd.menu.device_task',
        component: deviceTask,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/logManage',
        name: 'yd.menu.log_manage',
        component: LogManage,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      //参数配置相关
      {
        path: '/appParamConfig/add',
        name: 'yd.menu.param_add',
        component: AddAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/appParamConfig/edit',
        name: 'yd.menu.param_edit',
        component: EditAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/appParamConfig/editReal',
        name: 'yd.menu.param_edit1',
        component: EditAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/appParamConfig/view/:configCode',
        name: 'yd.menu.param_view',
        component: ViewAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      // {
      //   path: '/notFound',
      //   name: 'yd.menu.notfound',
      //   component: NotFound
      // },
      {
        path: '/organizationManagement',
        name: 'yd.menu.organization_management_another',
        component: organizationManagement,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/orgRepository',
        name: 'yd.menu.organization_management_repository',
        component: orgRepository,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },

      {
        path: '/operationLog',
        name: 'yd.menu.operation_log',
        component: operationLog,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/platformSettings',
        name: 'yd.menu.platform_settings',
        component: platformSettings,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/ota',
        name: 'yd.menu.ota',
        component: os,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/lifeCycle',
        name: 'yd.menu.device_life_cycle',
        component: deviceLifeCycle,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/dvcConnAnalysis',
        name: 'yd.menu.device_conn_analysis',
        component: dvcConnAnalysis,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/dvcLocationChange',
        name: 'yd.menu.device_location_change',
        component: locationChange,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },{
        path: '/report/networkConnAnalysis',
        name: 'yd.menu.network_conn_analysis',
        component: netConnectAnalysis,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/aliveDeviceAnalysis',
        name: 'yd.menu.alive_device_analysis',
        component: aliveDevice,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      // {
      //   path: '/opt',
      //   name: 'yd.menu.opt',
      //   component: otp,
      //   icon: 'icon-z-zuzhijiegou',
      //   meta: {
      //     requiresAuth: true, // 是否需要登录
      //     nocache: true
      //   }
      // },
      {
        path: '/mas',
        name: 'yd.menu.mas_list',
        component: mas,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/paramManage/dict',
        name: 'yd.menu.paramManage_dict',
        component: paramDict,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      // {
      //   path: '/paramManagement/manage',
      //   name: 'yd.menu.paramManage_manage',
      //   component: paramManage,
      //   icon: 'icon-z-zuzhijiegou',
      //   meta: {
      //     requiresAuth: true, // 是否需要登录
      //     nocache: true
      //   }
      // },
      {
        path: '/sysCustomization/silentApp',
        name: 'yd.menu.silentApp',
        component: silentApp,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/deviceTask/customDesk',
        name: 'yd.menu.customDesk',
        component: customDesk,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/sysCustomization/bootAnimation',
        name: 'deviceConfig.bootAnimation.tab_name',
        component: BootAnimation,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/policyManagement/configurationManagement',
        name: 'yd.configureManage.table.table_name',
        component: ConfigurationManagement,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/flowManagement/flowManage',
        name: 'yd.menu.flow_manage',
        component: FlowManage,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/flowManagement/flowLimitWarn',
        name: 'yd.menu.flowLimitWarn',
        component: flowLimitWarn,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/bulkTask',
        name: 'yd.menu.bulk_task',
        component: bulkTask,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/exportTask',
        name: 'yd.menu.export_task',
        component: exportTask,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/report/deviceAppInstallStatistics',
        name: 'yd.menu.deviceApp_installStatistics',
        component: deviceAppInstallStatistics,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/firstLogin',
    name: 'firstLogin',
    component: firstLogin,
    meta: {
      requiresAuth: true, // 是否需要登录
      nocache: true
    }
  },
  {
    path: '/unlock/:account/:code',
    name: 'unlock',
    component: unlock
  },
  {
    path: '/operateDate',
    name: 'operateDate',
    component: operateDate
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound
  },


]

export default routes;
